import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { weatherApi } from 'src/Services/API';

const useFetchWeatherForMyAssets = () => {
  const { i18n } = useTranslation();

  const tuple = useQuery({
    queryKey: ['fetch-weather-for-my-assets'],
    queryFn: async () => {
      const languageCode = i18n.language.toLowerCase().split('-')[0];
      return (await weatherApi.weatherControllerForAllMyAssets(languageCode)).data;
    },
    // Refresh the weather every 60 minutes.
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });

  useEffect(() => {
    tuple.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  return tuple;
};

export default useFetchWeatherForMyAssets;
